import ApiService from './api.service'
import { TokenService } from './storage.service'

const QuoteWorkflowService = {
    performWorkflowAction: async (quoteData) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteWorkflow/PerformWorkflowAction',
            data: quoteData,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    generateQuotePdf: async (id) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteWorkflow/GenerateQuotePdf?id=' + id,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    getInitQuoteSendingEmailData: async (id) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteWorkflow/GetInitQuoteSendingEmailData?id=' + id,
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    sendEmail: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteWorkflow/SendEmail',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    uploadQuoteFile: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteFileUpload/UploadQuoteFile',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
}

export default QuoteWorkflowService